<style lang="scss" src='./GwPassword.scss' scoped></style>
<template src="./GwPassword.html"></template>

<script>
export default {
  name: 'GwPassword',
  components: {
  },
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      required: true,
    },
    gClass: {
      required: false,
    },
    gRequired: {
      required: false,
      default: false
    },
    gPlaceholder: {
      required: false,
      default: ''
    }
  },
  data() {
    return ({
      inputType: 'password',
    });
  },
  computed: {
  },

  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },

    toggleInputType() {
      this.inputType = this.inputType === "password" ? "text" : "password";
    }
  },

  beforeCreate() {},

  created() {},

  mounted() {
  },

  beforeDestroy() {
  },

  };

</script>
